import { AuthProvider } from './../auth/auth';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController } from 'ionic-angular';
import { Observable } from 'rxjs';
import { ENV } from '../../environments/environment';
import { TaskNote, TaskQL, Task } from '../tasks/models';
import { LocationProvider } from '../location/location';
import { ProvidersProvider } from '../providers/providers';
import { getValue } from '../tasks/filters';

export interface MaintenanceStatus {
  'message'?:  string;
  'enabled'?:  boolean;
}

@Injectable()
export class UtilsProvider {
  constructor(
    public http: HttpClient,
    public alertCtrl: AlertController,
    private authProvider: AuthProvider,
    private locationProvider: LocationProvider,
    private providersProvider: ProvidersProvider,
  ) {}

  public multipleLoggins = false;

  handleGraphError(error, display = false) {

    const lowerError = JSON.stringify(error).toLowerCase();
    if(lowerError.includes('500 ok') && lowerError.includes('network error')){
      // Reload jwt expired
      this.clearCache();
    } else {
      const message =
        error.networkError &&
        error.networkError.error &&
        error.networkError.error.errors
          ? error.networkError.error.errors.map(err => err.message).join('. ')
          : 'An unknown error occurred';
      if (display) {
        let alert = this.alertCtrl.create({
          title: 'Error',
          message: message,
          buttons: ['OK']
        });
        alert.present();
      }
    }
  }

  handleAPIError(error, display = false) {
    console.log('ERROR::: ', error);
    const message =
      error && error.error && error.error.message
        ? error && error.error && error.error.message
        : 'An unknown error occurred';
    if (display) {
      let alert = this.alertCtrl.create({
        title: 'Error',
        message: message,
        buttons: ['OK']
      });
      alert.present();
    }
  }


  hasInvoice(taskID) {
    return Observable.create(observer => {
      let api = ENV.api + '/api/tasks/invoices/details/' + taskID;
      this.authProvider.getOptions().subscribe(options => {
        this.http.get(api, options).subscribe(
          uploadResult => {
            observer.next(uploadResult);
          },
          e => {
            console.log('e',e);
            observer.error(e);
          }
        );
      });
    });
    return true
  }

  uploadImages(images, id = 0, obs = null, taskid) {
    let observer;
    setTimeout(() => {
      if(images[id]){
        let postData = {
          content:images[id].data,
          contentType: 'image/jpeg'
        }
        this.authProvider.getOptions().subscribe(options => {
          let api = ENV.api + '/api/images';
          this.http.post(api, postData, options).subscribe(
            uploadResult => {
              const url = (uploadResult as any).url.replace('https://','');
              observer.next({
                data: {
                  src: url,
                  label: images[id].label ? images[id].label : '',
                  tag: images[id].tag ? images[id].tag : '',
                  comment: images[id].comment ? images[id].comment : ''
                },
                id: id
              });
              if (id < images.length - 1) {
                this.uploadImages(images, id + 1, observer, taskid);
              } else {
                observer.complete();
              }
            },
            e => {
              observer.complete();
            }
          );
        });
      } else {
        observer.complete();
      }
    }, 100);

    let obsobj;
    if (obs) {
      observer = obs;
    } else {
      obsobj = Observable.create(obs => {
        observer = obs;
      });
    }
    return obsobj;
  }


  uploadInvoice(invoice, name, obs = null, taskid) {
    return Observable.create(observer => {
      this.authProvider.getOptions().subscribe(options => {
        let api = ENV.api + '/api/tasks/invoices/createInvoiceUpload';
        const postData = {
          taskSnn: taskid,
          fileName: name,
          contentType: invoice.contentType,
          content: invoice.content
        }
        this.http.post(api, postData, options).subscribe(
          uploadResult => {
            observer.next(uploadResult);
          },
          e => {
            observer.error(e);
          }
        );
      });
    });



    // let obsobj;
    // if (obs) {
    //   observer = obs;
    // } else {
    //   obsobj = Observable.create(obs => {
    //     observer = obs;
    //   });
    // }
    // return obsobj;
  }

  getUserData() {
    return this.authProvider.userData
  }




  b64toBlob(b64Data, contentType = '', sliceSize: number = 512) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  toHTMLlinks(arr: Array<any>) {
    let links = '';
    for (let i = 0; i < arr.length; i++) {
      links += '<a href="' + arr[i] + '"  target="_blank">Image ' + (i + 1) + '</a><br>';
    }
    return links;
  }

  toDataURL = url =>
    fetch(url)
      .then(response => response.blob())
      .then(
        blob =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
  );

  getMetadata() {
    return Observable.create(observer => {
      let api = ENV.manifest;
      const location = window.location.href + '';

      if(!location.includes('localhost')){
        this.http
          .get(api)
          .subscribe(response => {
            observer.next(response);
          }, e => {
            console.log('e',e);
            observer.next(e);
          })
        } else {
          observer.next({});
        }
    });
  }
  checkVersion(){
      try {
            this.getMetadata().subscribe(ret => {
              if(!ret || (ret && !ret.version)){
                console.log('No Manifest App version: ', (ret));
              }
              const appversionStr = ret && ret.version ? ret.version : "0.0.0"
              const localVersion: string = localStorage.getItem('app-version');
              if(localVersion){
                if(localVersion !== appversionStr) {
                  if(ret && ret.version) {
                    this.clearCache();
                  } else {
                    console.log('Not Clearing' , appversionStr ,  localVersion)
                  }
                }
              } else {
                console.log("Setting App version",  appversionStr)
                localStorage.setItem('app-version', appversionStr+"")
              }
            });
      } catch (e) {
        console.log('Version check fail!')
      }
      this.userSyncCheck();
  }

  userSyncCheck(){
    if(this.multipleLoggins) return;
    const localUser = localStorage.getItem('currentUser');
    if(!localUser) return;
    const signInUser = this.authProvider.getUserId()

    if(localUser && signInUser && localUser !== signInUser ){
      this.multipleLoggins = true;
      const message = "Another user session in progress!\n You cannot be signed into multiple accounts at the same time."
      let alert = this.alertCtrl.create({
        title: 'Error',
        message: message,
        buttons: [{
          text: 'OK',
          handler: () => {
            window.location.reload();
          },
        }]
      });
      alert.present();
    }
  }

  clearCache() {
    localStorage.clear();
    sessionStorage.clear();
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (let registration of registrations) {
        registration.unregister();
      }
    }).then(() => {
      console.log('Reloading Now')
      localStorage.removeItem('app-version')
      window.location.reload();
    }).catch((err) => {
      console.log("Task Service Worker Error: ", err)
    });
  }

  removeNulls(obj){
    const keys = Object.keys(obj);
    keys.forEach(key => {
      let value = obj[key];
      if(value === null) {
        delete obj[key];
      } else if(typeof value === 'object'){
        obj[key] = this.removeNulls(value)
        if(obj[key] === null) delete obj[key];
      }
    })
    return obj
  }

  checkMaintenanceMode(){
    return Observable.create(observer => {
      const api = ENV.base + `/sensor-desk/maintenance`;
      this.authProvider.getOptions().subscribe(options => {
        this.http.get(api, options).subscribe(
          result => {
            const maintenanceActive = (result as MaintenanceStatus);
            observer.next(maintenanceActive);
          },
          error => {
            console.log('error',error);
          }
        );
      });
    });
  }

  async resizeImg(file: Blob): Promise<Blob> {
    let img = document.createElement("img");
    img.src = await new Promise<any>(resolve => {
        let reader = new FileReader();
        reader.onload = (e: any) => resolve(e.target.result);
        reader.readAsDataURL(file);
    });
    await new Promise(resolve => img.onload = resolve)
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    let MAX_WIDTH = 1100;
    let MAX_HEIGHT = 850;
    let width = img.naturalWidth;
    let height = img.naturalHeight;
    if (width > height) {
        if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
        }
    } else {
        if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
        }
    }
    canvas.width = width;
    canvas.height = height;
    ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, width, height);
    let result = await new Promise<Blob>(resolve => { canvas.toBlob(resolve, 'image/jpeg', 0.8); });
    return result;
  }

  serialize(obj) {
    const str = Object.keys(obj)
      .reduce(function(a, k) {
        a.push(k + '=' + obj[k]);
        return a;
      }, [])
      .join('&');
    return str.length > 0 ? '?' + str : '';
  }

  groupSnnToName(item: string) {
    if (item && item.includes("snn:group:company:")) {
      const name = item.replace("snn:group:company:", "").replace(/-/g, ' ');
      return name.charAt(0).toUpperCase() + name.slice(1);
    }
    return item;
  }

  fixImgUrls(notes: TaskNote[]){
    return notes.map(note => {
      if(note.note.includes('"sn-sensordesk-image')){
        note.note = note.note.replace('"sn-sensordesk', '"https://sn-sensordesk')
      }
      return note
    })
  }

  fixUrls(url: string){
    if(url && !url.startsWith('http')) return 'https://' + url;
    return url;
  }

  hideTaskFromUser(task: TaskQL | Task){
    const unscheduled = (task.status === Task.StatusEnum.Unscheduled || task.status === Task.StatusEnum.ToReschedule);
    if(unscheduled && this.scheduleStateHideCheck(task)) return true;
    return this.distanceFromTaskHideCheck(task);
  }

  scheduleStateHideCheck(task: TaskQL | Task){
    // checks schedulerMeta for reasons to hide or show task to user
    const isCurrentUser = task.schedulerMeta?.acceptedSchedulerSnn === this.authProvider.userData.data.uid; // checks to see if it is accepted by current user
    const timeRunOut = new Date().getTime() > task.schedulerMeta?.expiredTime;
    let shouldHide = false;
    if(task.schedulerMeta?.acceptedSchedulerSnn && task.schedulerMeta?.acceptedSchedulerSnn.length > 0) {
      shouldHide = true;
      if(isCurrentUser) shouldHide = false;
      if(timeRunOut) shouldHide = false;
    }
    return shouldHide;
  }


  unscheduledHideCheck(task: TaskQL | Task){
    // checks schedulerMeta for reasons to hide or show task to user
    const isCurrentUser = task.schedulerMeta?.acceptedSchedulerSnn === this.authProvider.userData.data.uid; // checks to see if it is accepted by current user
    const timeRunOut = new Date().getTime() > task.schedulerMeta?.expiredTime;
    let shouldHide = true;
    if(task.schedulerMeta?.acceptedSchedulerSnn && task.schedulerMeta?.acceptedSchedulerSnn.length > 0) {
      if(isCurrentUser) shouldHide = false;
      if(timeRunOut) shouldHide = true;
    }
    return shouldHide;
  }

  getProviderName(id, providers) {
    let provider = providers.filter(itm => itm.id === id)[0];
    let lbl = provider && provider.name ? provider.name : 'none';
    lbl = lbl === 'none' ? this.groupSnnToName(id) : lbl;
    return lbl;
  }

  getProviderColor(id, providers) {
    let provider = providers.filter(itm => itm.id === id)[0];
    let clr = provider && provider.color ? provider.color : '#666';
    return clr;
  }

  distanceFromTaskHideCheck(task: TaskQL | Task): boolean{
    const userLocation = this.locationProvider.getUserLocation();
    const address = task.address;
    const distance = this.getKmFromLatLng(
      address.latitude,
      address.longitude,
      userLocation?.coords.latitude,
      userLocation?.coords.longitude
    );
    const scheduleCompany = this.authProvider.getScheduleCompany();
    const company = this.providersProvider.getCachedCompanyById(scheduleCompany);
    const metaRange = getValue(company, 'meta.geyser:contact.range');
    const metaLocations = getValue(company, 'meta.geyser:contact.locations');
    const range = metaRange? metaRange: 50;
    if (metaLocations && metaLocations.length > 0){
      let inRange = false;
      metaLocations.map((companyLocation) => {
        let locationRange = companyLocation.range ? companyLocation.range : range;
        const distance = this.getKmFromLatLng(
          address.latitude,
          address.longitude,
          companyLocation?.location?.latitude,
          companyLocation?.location?.longitude
        );
        const distanceCheck = distance <= locationRange;
        inRange = inRange ? true : distanceCheck;
      })
      return inRange ? false : true;
    } else{
      return distance > range;
    }
  }

  getKmFromLatLng(lat1: number, lng1: number, lat2: number, lng2: number) {
    // Get the distance between two points in km
    const R = 6371;
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lng2 - lng1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return (R * c);
  }

  deg2rad(deg: number): number{
    return deg * (Math.PI / 180)
  }

  millisToMinutesAndSeconds(millis, fromMinutes?: boolean) {
    let minutes;
    if (fromMinutes) {
      minutes = this.minutesToHHMM((Math.floor(millis / 60000)));
    } else {
      minutes = Math.floor(millis / 60000);
    }
    let seconds = Number(((millis % 60000) / 1000).toFixed(0));
    return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
  }

  minutesToHHMM(minutes) {
    const HH = Math.floor(minutes/60);
    const MM = minutes - (HH * 60);
    return HH > 0  ? HH + ":" + MM : minutes;
  } 
}



// WEBPACK FOOTER //
// ./src/providers/utils/utils.ts